import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { Translate } from "react-redux-i18n";
import Constants from "../../AppConstants/Constants";
import PreviewCartItem from "../PreviewCart/PreviewCartItem";
import { setWizardInProgressData, updateWizardInProgressModalState } from "../../Store/Modals/Actions";

class TopBar extends Component {
    constructor(props) {
        super(props);

        this.onCartClick = this.onCartClick.bind(this);
    }

    onCartClick() {
        const { tempCart, history, setWizardInProgressData, updateWizardInProgressModalState } = this.props;

        if (tempCart.Kit && (!tempCart.Plan || !tempCart.Service)) {
            setWizardInProgressData({
                url: Constants.ENDPOINTS.CART
            });
            updateWizardInProgressModalState(true);
        } else {
            history.push(Constants.ENDPOINTS.CART);
        }
    }

    showPreview() {
        $("#cartPreview").css("display", "block");
    }

    hidePreview() {
        $("#cartPreview").css("display", "none");
    }

    renderCartPreview() {

        if (this.props.cart.items && this.props.cart.items.length > 0) {
            return (
                <div id="cartPreview" onMouseEnter={this.showPreview} onMouseLeave={this.hidePreview} style={
                    {
                        display: "none",
                        zIndex: "100",
                        position: "absolute",
                        right:"15px",
                        top: "15px",
                        // backgroundColor: "rgba(255,255,0,0.5)",
                        marginTop: "14px",
                        paddingTop: "8px",
                        backgroundColor: "transparent"
                    }}>
                    <div className="bg-white" style={
                        {
                            borderRadius: "5px",
                            boxShadow: "5px 5px 15px rgba(0,0,0,0.15)",
                            width: "400px",
                            maxHeight: "300px",
                            overflowY: "auto",
                            overflowX: "hidden"
                        }}>
                        <div className="container px-0 text-right">
                            {/* style 2 requires px-0 here ^ */}
                            {this.props.cart.items.map((item, i) => {
                                if (i === 0) {
                                    return <PreviewCartItem key={i} image={item.picture.thumbImageUrl} description={item.productName} quantity={item.quantity} price={item.unitPrice} />
                                } else {
                                    return <div key={i}>
                                        <hr className="my-0" style={{ borderColor: "rgba(48, 148, 182, 0.5)" }}/>
                                        <PreviewCartItem image={item.picture.thumbImageUrl} description={item.productName} quantity={item.quantity} price={item.unitPrice} />
                                    </div>
                                }
                            })}
                        </div>
                    </div>
                </div>
            );
        } else {
            return <div id="cartPreview" className="bg-white" style={
                {
                    position: "absolute",
                    display: "none",
                    right:"15px",
                    zIndex: "100",
                    borderRadius: "5px",
                    boxShadow: "5px 5px 15px rgba(0,0,0,0.15)",
                    height: "150px",
                    width: "300px"
                }}>
                <div className="container d-flex flex-column h-100 text-center">
                    <div className="row mx-auto my-auto">
                        <div className="col-12">
                            <h4><Translate value="cart.cartEmpty" /></h4>
                        </div>
                    </div>
                </div>
            </div>
        }
    }

    renderCart() {
        const { cart: { items }, isAuthenticated } = this.props;
        let cartItems = 0;

        if (isAuthenticated) {
            if (items) {
                cartItems = _.reduce(items, function(sum, item) {
                    return sum + item.quantity;
                }, 0);
            }

            return <ul className="menu-horizontal pt-0">
                <li>
                    <Link to={Constants.ENDPOINTS.BUYING_GUIDE}>
                        <img className="logo buying-guide-logo" alt="logo" src={require("../../../Assets/Images/buying-guide-banner.png")} />
                    </Link>
                </li>
                <li>
                    <Link to="#" onClick={this.onCartClick} onMouseEnter={this.showPreview} onMouseLeave={this.hidePreview}>
                        <FontAwesomeIcon icon={faShoppingCart}/> {items && items.length > 0 && <span id="cart-counter" className="label label--inline">{cartItems}</span>}
                    </Link>
                </li>
            </ul>;
        }
    }

    onImgClick() {
        const { setWizardInProgressData, updateWizardInProgressModalState, history, tempCart } = this.props;
        const modalData = {};
        if (location.pathname.includes("/kits") && tempCart.Kit && (!tempCart.Plan || !tempCart.Service)) {
            modalData.url = "/";

            setWizardInProgressData(modalData);
            updateWizardInProgressModalState(true);
        } else {
            history.push("/");
        }


    }

    render() {
        return <section className="bar bar-3 bar--sm bg--secondary top-bar-container">
            <div className="container">
                <div className="row">
                    <div className="col-2 col-sm-3 text-left">
                        <div className="bar__module">
                            <Link to="#">
                                <img className="logo velsol-logo" alt="logo" onClick={() => this.onImgClick()} src={require("../../../Assets/Images/logo-velocitor-white.png")} />
                            </Link>
                        </div>
                    </div>
                    <div className="col-10 col-sm-9 text-right">
                        <div className="bar__module">
                            {this.renderCart()}
                        </div>
                        {this.renderCartPreview()}
                    </div>
                </div>
            </div>
        </section>;
    }
}

function mapStateToProps(state) {
    return {
        cart: state.cart,
        tempCart: state.tempCart,
        isAuthenticated: state.isAuthenticated
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setWizardInProgressData: setWizardInProgressData,
        updateWizardInProgressModalState: updateWizardInProgressModalState
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopBar));